export const defaultHeight = 24;
